// Route guard: only org admins can access. Reads role from OrgContext
// rather than running its own member-doc snapshot, so we don't pay for
// two listeners on the same data.

import { Navigate } from 'react-router-dom';
import { useOrg } from '../../contexts/OrgContext';

export default function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { role, loading } = useOrg();

  if (loading) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', height: '100vh', color: 'var(--muted)' }}>
        Loading…
      </div>
    );
  }

  if (role !== 'admin') {
    // Member or missing — bounce home rather than show a permission-denied
    // page they can't act on.
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
